module.exports = __webpack_public_path__ + "static/media/team-sweiner.9c8ce272.jpg";